var _path, _rect, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPanels(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 25,
    viewBox: "0 0 15 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.10491 4.1206L1.92635 4.22998V5.53837V8.14131V9.14131L2.85986 8.78263L11.5358 5.44908L11.7977 3.38861L8.34924 3.63406L8.34086 3.63466L8.33244 3.63544L3.10491 4.1206Z",
    fill: "#9E523B",
    stroke: "#9E523B",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12.7937,
    height: 3.58314,
    transform: "matrix(0.933513 -0.358681 0 1 2.09082 11.7988)",
    fill: "#FD9879"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.64355 17.6582L1.71004 18.0169V19.0169V21.6198V22.6629L2.6829 22.2451L10.5252 18.8775L11.13 18.6178L11.3534 17.9293L12.1871 15.3604L12.6948 13.7962L11.3195 14.3247L2.64355 17.6582Z",
    fill: "#EE8E7A",
    stroke: "#EE8E7A",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanels);
export default __webpack_public_path__ + "static/media/panels.1b1401668835c9599ce10a623a849b60.svg";
export { ForwardRef as ReactComponent };